module.exports = __webpack_public_path__ + "static/media/wallet.3c209682.svg";